
import React from 'react';
import { Button } from "@material-ui/core";

const RenderButton = (buttonText, handleClick, componentProps = {}, linkProps = {}) => {
    return (
        <Button
            variant="contained"
            color="primary"
            onClick={handleClick}
            style={{ textTransform: "none", width: "120px", height: "36px", color: "#FFFFFF" }}
            {...componentProps}
            {...linkProps}
        >
            {buttonText}
        </Button>
    );
}

export default RenderButton;